import { render, staticRenderFns } from "./editGroup.vue?vue&type=template&id=74cf3156&scoped=true&"
import script from "./editGroup.vue?vue&type=script&lang=js&"
export * from "./editGroup.vue?vue&type=script&lang=js&"
import style0 from "./editGroup.vue?vue&type=style&index=0&id=74cf3156&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cf3156",
  null
  
)

export default component.exports